var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSquareCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_969_3829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.83334 27V9C7.83334 8.60218 7.99138 8.22064 8.27268 7.93934C8.55399 7.65804 8.93552 7.5 9.33334 7.5H39.3333C39.7312 7.5 40.1127 7.65804 40.394 7.93934C40.6753 8.22064 40.8333 8.60218 40.8333 9V39C40.8333 39.3978 40.6753 39.7794 40.394 40.0607C40.1127 40.342 39.7312 40.5 39.3333 40.5H25.8333",
    stroke: "#FF7180",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83334 36L12.3333 40.5L22.8333 30",
    stroke: "#FF7180",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_969_3829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#FF7180",
    transform: "translate(0.333344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSquareCheck);
export default __webpack_public_path__ + "static/media/icon_square_check.c928b7084d660cbc70c987fcc20169a8.svg";
export { ForwardRef as ReactComponent };